import React from 'react';
import PropTypes from 'prop-types';

export default class QuantityInput extends React.Component {
  static preventDefaultAction(event) {
    event.preventDefault();
  }

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
    };
  }
  componentWillReceiveProps(props) {
    this.setState({ value: props.value });
  }

  changeInputValue(event) {
    let newValue = String(event.target.value).replace(/[\uFF10-\uFF19]/g, ch =>
      String.fromCharCode(ch.charCodeAt(0) - 65248),
    );

    newValue = newValue === '' ? newValue : Number(newValue);

    if ((newValue !== '') && (!newValue || newValue % 1 !== 0 || newValue > this.props.maximumQuantity)) {
      return;
    }

    if (this.props.onChangeHandler !== undefined) { this.props.onChangeHandler(newValue); }

    this.setState({
      value: newValue,
    });
  }

  render() {
    return (
      <input
        type="text"
        className={this.props.className}
        value={this.state.value}
        onPaste={event => QuantityInput.preventDefaultAction(event)}
        onDrop={event => QuantityInput.preventDefaultAction(event)}
        onChange={event => this.changeInputValue(event)}
        autoComplete="off"
        maxLength={this.props.maximumQuantity}
      />
    );
  }
}

QuantityInput.propTypes = {
  maximumQuantity: PropTypes.number.isRequired,
  onChangeHandler: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  className: PropTypes.string,
};

QuantityInput.defaultProps = {
  onUpdateQuantity: undefined,
  onChangeHandler: undefined,
  value: 0,
  className: '',
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/QuantityInput/QuantityInput.js